<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <div>
      <div v-if="entidade" class="row">
        <div class="col-sm-12">
          <div v-if="duam.dam_codigo" class="card border shadow-none overflow-hidden">
                <!-- Cabeçalho -->
                <div class="d-flex align-items-center justify-content-between px-3 py-2 border-bottom">
                  <div class="d-flex align-items-center gap-2">
                    <div>
                      <p class="text-muted mb-0" style="font-size:11px;">DUAM</p>
                      <p class="fw-medium mb-0" style="font-size:14px;">{{ duam.dam_codigo }}</p>
                    </div>
                  </div>
                  <div class="text-end">
                    <p class="text-muted mb-0" style="font-size:11px;">Vencimento original</p>
                    <p class="fw-medium mb-0" style="font-size:13px;">{{ duam.dam_data_venc_orig | formatDate }}</p>
                  </div>
                </div>

                <!-- Tributos -->
                <div class="px-3">
                  <table class="table table-sm mb-0">
                    <thead>
                    <tr>
                      <th class="text-uppercase text-muted fw-normal" style="font-size:11px;">Tributo</th>
                      <th class="text-uppercase text-muted fw-normal text-end" style="font-size:11px;">Valor</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="t in tributos" :key="t.trb_codigo">
                      <td style="font-size:13px;">{{ t.trb_nome }}</td>
                      <td class="text-end" style="font-size:13px;">{{ t.dut_valortotal | formatNumeroBr }}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>

                <!-- Totalizadores -->
                <div class="px-3 py-2 border-top">
                  <div class="d-flex justify-content-between mb-1" style="font-size:13px;" v-for="(label, field) in {
        dut_valortributo: 'Subtotal',
        dut_atualizacao:  'Atualização (+)',
        dut_juros:        'Juros (+)',
        dut_multa:        'Multa (+)',
        dut_desconto:     'Desconto (-)'
      }" :key="field">
                    <span class="text-muted">{{ label }}</span>
                    <span>{{ duam[field] | formatNumeroBr }}</span>
                  </div>
                </div>

                <!-- Total -->
                <div class="d-flex justify-content-between align-items-center px-3 py-2 border-top">
                  <span class="fw-medium" style="font-size:13px;">Total</span>
                  <span class="text-danger fw-medium" style="font-size:18px;">{{ duam.dut_valortotal | formatNumeroBr }}</span>
                </div>

                <!-- Rodapé: vencimento + ações -->
                <div class="d-flex align-items-center justify-content-between px-3 py-2 border-top bg-light">
                  <div>
                    <p class="text-muted mb-0" style="font-size:11px;">Vencimento atual</p>
                    <p class="fw-medium mb-0" style="font-size:15px;">{{ duam.dam_data_venc_atu | formatDate }}</p>
                  </div>
                  <button @click="showModalAlterarVencimento"
                          class="btn btn-outline-secondary btn-sm d-flex align-items-center gap-1">
                    <i class="bx bx-calendar"></i> Atualizar vencimento
                  </button>
                </div>

                <!-- Gerar pagamento -->
                <div v-if="entidade.par_tipo_cobranca === '1' || entidade.par_tipo_cobranca === '2'"
                     class="px-3 py-2 border-top d-print-none">
                  <div v-if="!(pix.pix_qr_code || boleto.status)">
                    <button @click="registrar()" class="btn btn-success btn-sm w-100 d-flex align-items-center justify-content-center gap-1">
                      <i class="bx bx-receipt"></i> Gerar guia de pagamento (Pix, Boleto)
                    </button>
                  </div>
                </div>

              </div>
          <div v-else class="row mt-3">
            <div class="col-sm-12">
              <b-card header-class="bg-transparent border-primary" class="border border-primary">
                <h5 class="my-0 text-primary">
                  <i class="bx bx-x mr-3"></i>DUAM Indisponível para Pagamento
                </h5>
              </b-card>
            </div>
          </div>
        </div>
        <div v-if="pix.pix_qr_code" class="col-sm-12">
          <PixView :dam_hash="$route.params.dam_hash" :qrCodeUrl="pix.pix_qr_code"
                   :pix-copy-paste-code="pix.pix_qr_code" :order-id="'pix-'+pix.pix_codigo"/>
        </div>
        <div v-if="boleto.status" class="col-sm-6">
          <div v-if="boleto.bol_linha_digitavel">
            <BoletoView :dam_hash="$route.params.dam_hash" :barcodeCode="boleto.bol_linha_digitavel"
                        :boletoUrl="boleto.bol_link"/>
          </div>
        </div>
        <div v-if="boleto.status" class="col-sm-6">
          <div v-if="boleto.bol_qr_code">
            <PixView :dam_hash="$route.params.dam_hash" :dam_codigo="boleto.dam_codigo" :qrCodeUrl="boleto.bol_qr_code"
                     :pix-copy-paste-code="boleto.bol_qr_code" :order-id="'pix-'+boleto.bol_codigo"/>
          </div>
        </div>
        <div v-if="entidade.par_tipo_cobranca === '3' && this.duam.vencida" class="col-sm-12">
              <b-card header-class="bg-transparent border-primary" class="border border-primary">
                <h5 class="my-0 text-primary">
                  <i class="bx bx-x mr-3"></i>Atualize o vencimento para gerar a guia de pagamento
                </h5>
              </b-card>
            </div>
        <div v-if="entidade.par_tipo_cobranca === '3' && !this.duam.vencida" class="col-sm-6">
            <SemAPIView :dam_hash="$route.params.dam_hash"/>
        </div>
      </div>
      <modal :height="'auto'" :clickToClose="false" :adaptive="true" :draggable="true" name="modal-alterar-vencimento">
        <div class="card mb-0">
          <div class="card-body">
            <div class="row">
              <div class="col-md-8">
                <h5 class="mt-1 mb-4">Atualizar Vencimento</h5>
              </div>
              <div class="col-md-4 text-right">
                <button type="button" @click="hideModalAlterarVencimento()" title="Fechar"
                        class="btn btn-outline-dark btn-sm mr-2 mt-0"><i class="bx bx-x"></i> Fechar
                </button>
              </div>
            </div>
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-4">
                  <b-form-group label="N° da DUAM">
                    <h6 class="mb-0">{{ duam.dam_codigo }}</h6>
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group label="Vencimento Original">
                    <h6 class="mb-0">{{ duam.dam_data_venc_orig | formatDate }}</h6>
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group label="Valor Original" label-for="dut_valortributo">
                    <h6 class="mb-0">{{ duam.dut_valortributo | formatNumeroBr }}</h6>
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <b-form-group
                      label="Novo Vencimento"
                      label-for="novo_vencimento">
                    <input :key="resetKeyNovoVencimento" id="novo_vencimento" @change="validarFimDeSemana"
                           v-model="duam.novo_vencimento" type="date"
                           class="form-control">
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group label="Total Atualizado">
                    <input v-bind:value="duam.novo_valor | formatNumeroBr" disabled type="text" class="form-control">
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group
                      label-class="text-white"
                      label="´">
                    <button type="button" title="Realizar Alteração"
                            @click="confirmacaoAlteracaoVencimento"
                            v-bind:disabled="!duam.novo_vencimento"
                            class="btn btn-success">
                      <i class="bx bx-check-double"></i> Realizar Alteração
                    </button>
                  </b-form-group>
                </div>
              </div>
            </div>
          </div>
        </div>
      </modal>
    </div>
    <Aguarde :show="httpSend"></Aguarde>
  </Layout>
</template>

<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/dados/app.config.json";
import PageHeader from "@/components/page-header";
import Aguarde from "@/components/widgets/aguarde";
import {guiaPagamento} from "@/api/financeiro/guia";
import {alteracaoVencimentoDuam, registerPagamento, verificaAlteracaoVencimento} from "@/api/financeiro/pagamento";
import {dataSqlHtml} from "@/helps/util";
import Swal from "sweetalert2";
import {notifyAviso} from "@/helps/notificacao";
import PixView from "@/router/views/contribuinte/financeiro/components/PixView.vue";
import BoletoView from "@/router/views/contribuinte/financeiro/components/BoletoView.vue";
import SemAPIView from "./components/SemAPIView.vue";

const {notifyErro, notifySucesso} = require("../../../../helps/notificacao");

export default {
  page: {
    title: "Pagamento de DUAM",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    BoletoView,
    PixView,
    SemAPIView,
    Layout,
    PageHeader,
    Aguarde
  },
  created() {
    this.getGuia();
  },
  data() {
    return {
      order_pg: 0,
      size: 300,
      title: "Pagamento",
      items: [
        {
          text: 'Painel',
          href: '/painel',
        },
        {
          text: 'DUAMs',
          href: '/contribuinte/financeiro/guia',
        },
        {
          text: 'Pagamento',
          active: true,
        },
      ],
      par_chave_pix: null,
      not_hash: false,
      httpSend: false,
      entidade: null,
      resetKeyNovoVencimento: 0,
      duam: {
        dam_codigo: null,
        novo_vencimento: '',
        novo_valor: 0.00,
      },
      tributos: [],
      pagamento: {
        forma: 'pix',
        registrado: false
      },
      erros: {
        tipo: 1,
        status: false,
        titulo: '',
        mensagem: '',
        detalhe: null,
      },
      pix: {
        pix_qr_code: null,
        status: null,
        pix_hash: null,
        qr_code: '',
        pago: -1,
        info_pagamento: null,
      },
      boleto: {
        status: null,
        bol_hash: null,
        bol_linha_digitavel: null
      },
    };
  },
  methods: {
    p_init() {
      if (!this.entidade.par_chave_pix) {
        this.pagamento.forma = 'boleto';
      }
    },
    resetErros() {
      this.erros = {
        tipo: 1,
        titulo: '',
        status: false,
        mensagem: '',
        detalhe: null,
      }
    },
    exibirPix(dados) {
      this.pix = dados;
      if (dados.qr_code) {
        this.pix.pix_qr_code = dados.qr_code;
      }
    },
    exibirBoleto(dados) {
      this.boleto = dados;
      this.boleto.status = true;
    },
    getGuia() {
      this.httpSend = true;
      guiaPagamento(this.$route.params.dam_hash).then(response => {
        if (response.status) {
          const dados = response.dados
          this.entidade = dados.entidade;
          this.tributos = dados.tributos;
          if (dados.guia) {
            if (dados.guia.dam_codigo) {
              this.duam = dados.guia;
              this.duam.novo_valor = parseFloat(dados.guia.dut_valortotal);
            }
          }
          if (dados.pix) {
            if (dados.pix.pix_hash) {
              this.exibirPix(dados.pix);
            }
          }
          if (dados.boleto) {
            if (dados.boleto.bol_hash) {
              this.exibirBoleto(dados.boleto)
            }
          }
          this.p_init();
        }
      }).catch(error => {
        console.log(error);
      }).finally(() => {
        this.httpSend = false;
      })
    },
    registrar() {
      if (this.pagamento.forma === 'pix' && this.pix.pix_qr_code) {
        Swal.fire({
          title: "Pix já está disponível",
          text: "O Pix para pagamento já está disponível",
          icon: "warning",
          showCancelButton: false,
          confirmButtonColor: "#100e0e",
          confirmButtonText: "Entendi",
        });
        return;
      }
      if (this.pagamento.forma === 'boleto' && this.boleto.bol_hash) {
        Swal.fire({
          title: "Boleto já está disponível",
          text: "O boleto para pagamento já está disponível",
          icon: "warning",
          showCancelButton: false,
          confirmButtonColor: "#100e0e",
          confirmButtonText: "Entendi",
        });
        return;
      }
      this.resetErros();
      this.httpSend = true;
      registerPagamento({dam_hash: this.duam.dam_hash}).then(response => {
        if (response.status) {
          notifySucesso("DattaNFSe", response.mensagem)
          this.getGuia();
        } else {
          const erro = response.dados;
          notifyErro("DattaNFSe", response.mensagem)
          this.erros.titulo = response.mensagem;
          this.erros.status = true;
          this.erros.mensagem = erro.mensagem;
          this.erros.detalhe = erro.info_erro;
        }
      }).catch(error => {
        notifyErro("DattaNFSe", error)
      }).finally(() => {
        this.httpSend = false
      })
    },
    showModalAlterarVencimento() {
      this.duam.novo_vencimento = dataSqlHtml(this.duam.dam_data_venc_atu);
      this.$modal.show('modal-alterar-vencimento');
    },
    hideModalAlterarVencimento() {
      this.$modal.hide('modal-alterar-vencimento');
    },
    validarFimDeSemana() {
      if (!this.duam.novo_vencimento) return;
      // Data selecionada (normalizada para meia-noite local)
      const dataSelecionada = new Date(this.duam.novo_vencimento + 'T00:00:00');
      // Data de hoje (normalizada para meia-noite local)
      const hoje = new Date();
      hoje.setHours(0, 0, 0, 0);
      const diaSemana = dataSelecionada.getDay(); // 0 = domingo, 6 = sábado
      // Regra 1: não permitir datas anteriores a hoje
      if (dataSelecionada < hoje) {
        notifyAviso("Atenção", "Não é permitido selecionar uma data anterior ao dia atual")
        this.duam.novo_vencimento = null;
        this.resetKeyNovoVencimento++;
        return;
      }
      // Regra 2: não permitir sábado ou domingo
      if (diaSemana === 0 || diaSemana === 6) {
        notifyAviso("Atenção", "Não é permitido selecionar sábado ou domingo")
        this.duam.novo_vencimento = null;
        this.resetKeyNovoVencimento++;
        return;
      }

      this.httpSend = true;
      verificaAlteracaoVencimento(this.duam.dam_codigo, this.duam.novo_vencimento).then(response => {
        if (response.status) {
          this.duam.novo_valor = parseFloat(response.dados.dut_valortotal);
        } else {
          notifyAviso("Atenção", response.mensagem)
        }
      }).catch(error => {
        notifyErro("Erro de Servidor", error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
    confirmacaoAlteracaoVencimento() {
      if (!this.duam.novo_vencimento) {
        return
      }
      Swal.fire({
        title: "Alterar Vencimento",
        html: "Confirma a alteração do vencimento para <b>" + dataSqlHtml(this.duam.novo_vencimento) + "</b>? <br> Atenção: Essa ação cancelará o Pix ou o Boleto já gerado para este débito.",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#100e0e",
        confirmButtonText: "Sim",
        cancelButtonText: "Não"
      }).then(result => {
        if (result.isConfirmed) {
          this.alterarVencimento()
        }
      });
    },
    alterarVencimento() {
      this.httpSend = true;
      alteracaoVencimentoDuam({
        dam_codigo: this.duam.dam_codigo,
        dam_data_venc_atu: this.duam.novo_vencimento
      }).then(response => {
        if (response.status) {
          notifySucesso("DattaNFSe", response.mensagem)
          this.hideModalAlterarVencimento()
          this.getGuia();
        } else {
          if (response.dados) {
            if (Array.isArray(response.dados) && response.dados.length > 0) {
              if ('action' in response.dados[0]) {
                notifyAviso("Atenção", response.dados[0].action)
              }
            }
          } else {
            notifyErro("Atenção", response.mensagem)
          }
        }
      }).catch(error => {
        notifyErro("Erro de Servidor", error)
      }).finally(() => {
        this.httpSend = false;
      })
    }
  }
};
</script>
<style lang="css">
.card-radio-input:checked + .card-radio {
  border-color: #34c38f !important;
}
</style>


